import Vue from 'vue'
import App from './App.vue'
import router from './router'
import moment from "moment";

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
  comments: true
}).$mount('#app')

Vue.filter('formatDate', function (value) {
  if (value) {
    //08 Jan, 2022
    return moment(String(value)).format('DD MMM, YYYY');
  }
});